export class IVA {
    id: string;
    factor: number;
    etiqueta: string;
    desde?: Date;
    hasta?: Date;
    ayuda?: string; 
}